module.exports = __webpack_public_path__ + "media/images/font/Gustavo-MediumItalic-9a69198052d6b6768954f9e5ab79c0ec.svg";